import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboCodLineaGenetica`, method: 'GET', body: null, token: token})
}
